import Service from "./Service";
const baseurl = '/api/historia/graficas';

export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
}